<template>
  <div class="winners-list-container grey--btn grey-border">
    <div class="title">
      <p>Winners List</p>
    </div> 
    <div class="list-wrapper grey-border-inner">
      <div class="list-content">
        <div class="winner-wrapper">
          <div class="list-index winner">
            <div class="number">No.</div>
            <div class="name">Name</div>
          </div>
        </div>
        <div class="winner-wrapper">
          <div 
            class="winner" 
            v-for="(winner, index) in winners"
            :key="index"
          >
            <div class="number">{{ winners.length - index}}</div>
            <div class="name">{{ winner.username }}</div>
          </div>
        </div>
      </div>      
    </div>   
  </div>
</template>

<script>

import { db } from '@/firebase'
export default {
  data(){
    return{
      winners:{}
    }    
  },
  firestore:{
    winners: db.collection('users').orderBy('winTime', "desc")
  }
}
</script>
<style lang="scss">
.winners-list-container{
  width: 100%;
  height: 400px;  
  margin-top: 40px; 
  .title{
    height: 60px;
    p{
      color: #1200f4;    
      font-size: 34px;
      font-family: Times New Roman,Times,serif; 
      font-weight: 700;
    }    
  }
  .list-wrapper{
    width: 100%;
    height: 330px;
    background: black;    
    overflow: auto;
    .list-content{ 
      .number, .name{
        display: inline-block;
        color:#00ff1e;                        
      }
      .number{
        width: 160px; 
      }
      .winner-wrapper{
        max-width: 540px;
        margin: auto;
        padding: 0 30px;            
        .winner{        
          padding: 8px;        
          font-size: 18px;
          border-bottom: 1px solid white;
          text-align: left;
        }
      }
      .list-index{
         padding: 10px 0;         
         div{
           font-size: 22px;
         }
      }      
    }    
  }
}
  
</style>

